import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import withAuth from "../../../components/withAuth";

// LIBS
import API from "../../../api";
import { fioFromObject } from "../../../lib/helpers/strings";
import { getDateFormat } from "../../../lib/helpers/dates";
import { getDocsType } from "../../../lib/helpers/users";

// UI
import {
  P,
  Header,
  HeaderPage,
  ButtonGroup,
  Button,
  Box,
  Row,
  Col
} from "../../../ui";

class AccountPage extends Component {
  state = {
    titleHeader: "Аккаунт",
    user: { role_id: {}, filial_id: {} }
  };

  async componentDidMount() {
    const user = await API.me.getInfo();

    if (user && user._id) {
      const { form } = this.state;

      // Заполняем форму
      for (let key in form) {
        if (form[key].isNumber) {
          form[key].value = String(user[key]) || "0";
        } else if (form[key].isDate) {
          form[key].value = getDateFormat(user[key]);
        } else {
          form[key].value = user[key] || "";
        }
      }

      this.setState({ user, form });
    }
  }

  render() {
    const { user } = this.state;

    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <HeaderPage title="Ваш аккаунт" back={this.props.history.goBack}>
          <ButtonGroup>
            <Button type="as" as={Link} to={`/settings/account/edit`}>
              Изменить
            </Button>
          </ButtonGroup>
        </HeaderPage>

        <Box>
          <Header size={2} margin="no-top">
            {user.username}
          </Header>

          <Row>
            <Col padding="no-top-left">
              <Header size={5} margin="no-top">
                Главное
              </Header>

              <Header size={6} margin="no-bottom">
                ФИО:
              </Header>
              <P slim>{fioFromObject(user)}</P>

              <Header size={6} margin="no-bottom">
                Филиал:
              </Header>
              <P slim>
                {(user.filial_id && user.filial_id.name) || "Не выбран"}
              </P>

              <Header size={6} margin="no-bottom">
                Роль:
              </Header>
              <P slim>{user.role_id.name || "Не назначена"}</P>

              <Header size={6} margin="no-bottom">
                Email:
              </Header>
              <P slim>{user.email || "Не указан"}</P>
            </Col>

            <Col padding="no-top-left">
              <Header size={5} margin="no-top">
                Документ
              </Header>

              <Header size={6} margin="no-bottom">
                ИИН:
              </Header>
              <P slim>{user.iin || "Не указан"}</P>

              <Header size={6} margin="no-bottom">
                Вид документа:
              </Header>
              <P slim>{getDocsType(user.docs)}</P>

              <Header size={6} margin="no-bottom">
                Номер документа:
              </Header>
              <P slim>{user.docs_number || "Не указан"}</P>

              <Header size={6} margin="no-bottom">
                Кем выдан:
              </Header>
              <P slim>{user.docs_give_from || "Не указано"}</P>

              <Header size={6} margin="no-bottom">
                Дата выдачи:
              </Header>
              <P slim>{user.docs_give_date || "Не указана"}</P>
            </Col>

            <Col padding="no-top-left">
              <Header size={5} margin="no-top">
                Прочее
              </Header>

              <Header size={6} margin="no-bottom">
                Телефон:
              </Header>
              <P slim>{user.tel || "Не указан"}</P>

              <Header size={6} margin="no-bottom">
                Адрес:
              </Header>
              <P slim>{user.address || "Не указан"}</P>
            </Col>

            <Col padding="no-top-left">
              <Header size={5} margin="no-top">
                Изменения
              </Header>

              <Header size={6} margin="no-bottom">
                Дата создания:
              </Header>
              <P slim>{getDateFormat(user.created_at)}</P>

              <Header size={6} margin="no-bottom">
                Дата обновления:
              </Header>
              <P slim>{getDateFormat(user.updated_at)}</P>
            </Col>
          </Row>
        </Box>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(withAuth(AccountPage));
